export enum MemberFeeContractStatus {
    issued = 1,
    pendingSignature = 2,
    signed = 3
}

const MEMBER_FEE_CONTRACT_STATUS_TRANSLATION_KEYS: Record<MemberFeeContractStatus, string> = {
    [MemberFeeContractStatus.issued]: 'contract_status_issued',
    [MemberFeeContractStatus.pendingSignature]: 'contract_status_pending_signature',
    [MemberFeeContractStatus.signed]: 'contract_status_signed'
};

const MEMBER_FEE_CONTRACT_STATUS_COLOR: Record<MemberFeeContractStatus, string> = {
    [MemberFeeContractStatus.issued]: 'default',
    [MemberFeeContractStatus.pendingSignature]: 'warning',
    [MemberFeeContractStatus.signed]: 'success'
};

export function getMemberFeeContractStatusText(status: MemberFeeContractStatus): string {
    return MEMBER_FEE_CONTRACT_STATUS_TRANSLATION_KEYS[status] ?? '';
}

export function getMemberFeeContractStatusColor(status: MemberFeeContractStatus): string {
    return MEMBER_FEE_CONTRACT_STATUS_COLOR[status] ?? 'default';
}
